
export function dynamicSort<T>(property: string, dir: string,
    propertyDataType: string = undefined): (a: T, b: T) => number {
  let sortOrder = (dir === "desc") ? -1 : 1;
  return (a, b) => {
    let result = -2;
    //something that is undefined or null is less than something that is not null or undefined
    if (a[property] === undefined && b[property] === undefined) {
      result = 0;
    } else if (a[property] === undefined) {
      result = -1;
    } else if (b[property] === undefined) {
      result = 1;
    }
    if (result != -2) {
      return result * sortOrder;
    }
    if (a[property] === null && b[property] === null) {
      result = 0;
    } else if (a[property] === null) {
      result = -1;
    } else if (b[property] === null) {
      result = 1;
    }
    if (result != -2) {
      return result * sortOrder;
    }

    
     if (propertyDataType == 'string') {
      //ensure both are strings
      //anything not a string is less than any string
      if (typeof a[property] != 'string' && typeof b[property] != 'string') {
        result = 0;
      } else if (typeof a[property] != 'string') {
        result = -1;
      } else if (typeof b[property] != 'string') {
        result = 1;
      }
      if (result != -2) {
        return result * sortOrder;
      }
    }

    let aValue, bValue;
    if (propertyDataType == 'number') {


      //remove commas
      aValue = a[property].replace(',', '');
      bValue = b[property].replace(',', '');

      aValue = Number.parseFloat(aValue);
      bValue = Number.parseFloat(bValue);
    } else {
      aValue = a[property];
      bValue = b[property];
    }
    result = (aValue < bValue) ? -1 : (aValue > bValue) ? 1 : 0;
    return result * sortOrder;
  };
}
